import React from "react";
import type { ResolvedQuestionnaire } from "../api";
import { serializeResolvedQuestionnaire } from "../serializeResolved";
import TextDiff from "./TextDiff";

const QuestionnaireDiff: React.VFC<{
  previous: ResolvedQuestionnaire;
  next: ResolvedQuestionnaire;
  previousLabel?: string;
  nextLabel?: string;
}> = ({ previous, next, previousLabel = "Previous", nextLabel = "Next" }) => (
  <TextDiff
    previous={React.useMemo(() => serializeResolvedQuestionnaire(previous), [previous])}
    next={React.useMemo(() => serializeResolvedQuestionnaire(next), [next])}
    previousLabel={previousLabel}
    nextLabel={nextLabel}
  />
);

export default QuestionnaireDiff;
